import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutActionCode extends Layout {
    sourceActionCode: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxNxtActionCodeId: Textbox;
    textboxNxtActionDays: Textbox;
}
